import React from 'react'
import {PhoneOutlined} from '@ant-design/icons'
import logoInviso from '../../assets/logo-inviso.png'
import './index.scss'

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <div className="inner">
        <h1>404 - SIDEN DU LETER ETTER FINNES IKKE</h1>
        <p>Vi beklager, men siden du leter etter er flyttet eller eksisterer ikke.</p>
        <h2>Du kan forsøke å:</h2>
        <ul>
          <li>Gå tilbake til <a href="/">hovedsiden</a></li>
          <li>Hvis du har skrevet inn adressen direkte, sjekk at det ikke er skrivefeil</li>
          <li>Gå tilbake og forsøk en annen link</li>
          <li>Finner du ikke det du leter, ta kontakt med oss på telefon 21 08 05 00</li>
        </ul>

        <div className="contact">
          <img src={logoInviso} alt="EFKT" width="84" height="16" />
          <div>
            <PhoneOutlined />
            21 08 05 00
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound
